import { Controller } from "@hotwired/stimulus"

// ConsLog Help Center (Phelipe 2026-10-07): click a screenshot to see it full
// size; a click anywhere or Escape closes it.
export default class extends Controller {
  static targets = ["zoom", "zoomImg"]

  connect() {
    this.onKey = (e) => { if (e.key === "Escape") this.unzoom() }
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  zoom(event) {
    const button = event.currentTarget
    const img = button.querySelector("img")
    this.back = button
    this.zoomImgTarget.src = button.dataset.src
    this.zoomImgTarget.alt = img ? img.alt : ""
    this.zoomTarget.classList.remove("hidden")
  }

  unzoom() {
    if (this.zoomTarget.classList.contains("hidden")) return
    this.zoomTarget.classList.add("hidden")
    this.zoomImgTarget.removeAttribute("src")
    if (this.back) this.back.focus()
  }
}
